import { useState } from 'react';
import { Tabs, Tab, TabList, TabPanel } from 'react-tabs';
import MediaGrid from './MediaGrid';
import UploadMediaPanel from './UploadMediaPanel';
import './mediaLibrary.css';

const MediaLibraryPage = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleUploaded = () => {
    setRefreshKey(k => k + 1);
  };

  return (
    <>
    <div
      className="datatable-header-row"
      style={{ justifyContent: "space-between" }}
    >
      <div style={{ fontSize: 18, fontWeight: 700, paddingLeft: 20 }}>
        Media Library
      </div>
    </div>
    <div className="tab-page">
    <Tabs selectedIndex={tabIndex} onSelect={setTabIndex}>
      <TabList>
        <Tab style={{fontSize:"1.1rem", padding:"5px 0 0 0"}}>Images</Tab>
        <Tab style={{fontSize:"1.1rem", padding:"5px 0 0 0"}}>Videos</Tab>
        <Tab style={{fontSize:"1.1rem", padding:"5px 0 0 0"}}>Upload</Tab>
      </TabList>

      <TabPanel>
        <div className="media-library-page" style={{ height: 'calc(100vh - 220px)', overflowY: 'auto' }}>
          <MediaGrid
            type="image"
            refreshKey={refreshKey}
          />
        </div>
      </TabPanel>

      <TabPanel>
        <div className="media-library-page" style={{ height: 'calc(100vh - 220px)', overflowY: 'auto' }}>
          <MediaGrid
            type="video"
            refreshKey={refreshKey}
          />
        </div>
      </TabPanel>

      <TabPanel>
        <UploadMediaPanel onUploaded={handleUploaded} />
      </TabPanel>
    </Tabs>
    </div>
    </>
  );
};

export default MediaLibraryPage;
